import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7633b7fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post" }
const _hoisted_2 = { class: "post__draggable" }
const _hoisted_3 = { class: "post__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "post__content" }
const _hoisted_6 = {
  key: 0,
  class: "timestamp__text"
}
const _hoisted_7 = {
  key: 1,
  class: "timestamp__text"
}
const _hoisted_8 = { class: "post__draggable" }
const _hoisted_9 = { class: "post__header" }
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "timestamp__text"
}
const _hoisted_15 = {
  key: 1,
  class: "timestamp__text"
}

import { useDraggable, useElementSize } from "@vueuse/core";
import { ref, toRefs, computed } from "vue";
import { PostItemType } from "@/types/props";
import { useStore } from "@/store";

// Store
type BeforeTranslateDate = "createdAt" | "updatedAt";

export default /*#__PURE__*/_defineComponent({
  props: {
    postItem: null,
    i: null
  },
  emits: [
  "change:size",
  "change:position",
  "focus:z-index",
  "delete:post",
  "change:draggableStatus",
  "save:post",
  "change:title",
  "change:contents",
],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  postItem: PostItemType;
  i: number;
}

const store = useStore();
const postColor = computed(() => store.state.postColor);
// Props

const { postItem, i } = toRefs(props);
// Emits


// State
const title = ref(postItem.value.title);
const contents = ref(postItem.value.contents);
const createdTime = computed(() => {
  return translateDate("createdAt");
});
const updatedTime = computed(() => {
  return translateDate("updatedAt");
});

// UTC Date 변환
function translateDate(beforeTranslate: BeforeTranslateDate) {
  const beforeTranslatedDate = postItem.value[beforeTranslate] as string;
  const year = new Date(beforeTranslatedDate).getFullYear();
  const month = new Date(beforeTranslatedDate).getMonth() + 1;
  let date = new Date(beforeTranslatedDate).getDate();
  if (date < 10) {
    let newDate = `0${date.toString()}`;
    date = parseInt(newDate);
  }
  const hour = new Date(beforeTranslatedDate).getHours();
  const minute = new Date(beforeTranslatedDate).getMinutes();
  return `${year}년 ${month}월 ${date}일 ${hour}:${minute}`;
}

// title state와 title input value 일치화
function matchTitle(e: Event) {
  const target = e.target as HTMLInputElement;
  title.value = target.value;
}
// contents state와 contents textarea value 일치화
function matchContents(e: Event) {
  const target = e.target as HTMLTextAreaElement;
  contents.value = target.value;
}

function emitDeletePost() {
  emits("delete:post", postItem.value._id);
}

// 현재 title이 props로 받은 title과 다르다면 emit
function emitChangeTitle() {
  const titleData = {
    title: title.value,
    index: i.value,
  };
  if (title.value !== postItem.value.title) {
    emits("change:title", titleData);
  }
}

// 현재 contents가 props로 받은 contents와 다르다면 emit
function emitChangeContents() {
  const contentsData = {
    contents: contents.value,
    index: i.value,
  };
  if (contents.value !== postItem.value.contents) {
    emits("change:contents", contentsData);
  }
}

// 드래그 불가능 && width 또는 height가 props로 받은 width 또는 height와 다르다면 emit
function emitChangeSize() {
  const sizeData = {
    width: sizeWidth.value,
    height: sizeHeight.value,
    index: i.value,
  };
  if (
    !postItem.value.isDraggable &&
    (sizeWidth.value !== postItem.value.position.width ||
      sizeHeight.value !== postItem.value.position.height)
  ) {
    emits("change:size", sizeData);
  }
}

// 드래그 상태 토글
function emitChangeDraggableStatus() {
  const draggableStatus = {
    status: !postItem.value.isDraggable,
    index: i.value,
  };
  emits("change:draggableStatus", draggableStatus);
}

// 드래그 가능한 상태라면 포스트 저장 emit
function emitSavePost() {
  if (postItem.value.isDraggable) emits("save:post", i.value);
}

// Draggable 토글
function setDraggable() {
  emitChangeTitle();
  emitChangeContents();
  emitChangeSize();
  emitChangeDraggableStatus();
  emitSavePost();
}

// useDraggable / useElementSize
const postDraggableElement = ref<HTMLElement | null>(null);
const postSizeElement = ref<HTMLElement | null>(null);
const { width: sizeWidth, height: sizeHeight } =
  useElementSize(postSizeElement);

const { x, y, style } = useDraggable(postDraggableElement, {
  exact: false,
  initialValue: {
    x: postItem.value.position.x,
    y: postItem.value.position.y,
  },
  // 클릭한 엘레먼트의 z-index를 최상위로 올림
  onStart: () => {
    if (postItem.value.position.z === 1) {
      emits("focus:z-index", {
        z: 2,
        index: i.value,
      });
    }
  },
  // 드래그 종료시 position 값을 emit
  onEnd: () => {
    if (
      x.value !== postItem.value.position.x ||
      y.value !== postItem.value.position.y
    ) {
      // x 또는 y가 props로 받은 x 또는 y와 다르다면 emit
      emits("change:position", {
        x: x.value,
        y: y.value,
        index: i.value,
      });
      // props 변경 후 emit
      emits("save:post", i.value);
    }
    if (postItem.value.position.z === 2) {
      emits("focus:z-index", {
        z: 1,
        index: i.value,
      });
    }
  },
});
const btnGroupDraggable = ref<HTMLDivElement>();
const btnGroupSizable = ref<HTMLDivElement>();
const timestampSizable = ref<HTMLDivElement>();
const timestampDraggable = ref<HTMLDivElement>();
// 포스트 위에 마우스 올릴 시 버튼을 보여줌
function onMouseOver(el: HTMLDivElement | undefined) {
  if (el) el.classList.remove("hidden");
}
// 포스트 위에서 마우스가 사라지면 버튼을 사라지게 함
function onMouseLeave(el: HTMLDivElement | undefined) {
  if (el) el.classList.add("hidden");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => {
        onMouseOver(btnGroupDraggable.value);
        onMouseOver(timestampDraggable.value);
      }),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => {
        onMouseLeave(btnGroupDraggable.value);
        onMouseLeave(timestampDraggable.value);
      }),
      class: "post__item draggable",
      ref: (_value, _refs) => {
        _refs['postDraggableElement'] = _value
        postDraggableElement.value = _value
      },
      style: _normalizeStyle([
        _unref(style) +
        `width:${_unref(postItem).position.width}px; height:${_unref(postItem).position.height}px; z-index:${_unref(postItem).position.z}; background-color:${_unref(postColor)}`
      , {"position":"fixed"}]),
      onDblclick: setDraggable
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", null, _toDisplayString(title.value), 1),
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['btnGroupDraggable'] = _value
              btnGroupDraggable.value = _value
            },
            class: "post__btnGroup hidden"
          }, [
            _createElementVNode("i", {
              class: "far fa-trash-alt",
              onClick: emitDeletePost
            })
          ], 512)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(contents.value), 1)
      ]),
      _createElementVNode("div", {
        ref: (_value, _refs) => {
          _refs['timestampDraggable'] = _value
          timestampDraggable.value = _value
        },
        class: "timestamp hidden"
      }, [
        (!_unref(updatedTime))
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(createdTime)) + " 생성됨", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(updatedTime)) + " 수정됨", 1))
      ], 512)
    ], 36), [
      [_vShow, _unref(postItem).isDraggable]
    ]),
    _withDirectives(_createElementVNode("div", {
      onMouseover: _cache[7] || (_cache[7] = ($event: any) => {
        onMouseOver(btnGroupSizable.value);
        onMouseOver(timestampSizable.value);
      }),
      onMouseleave: _cache[8] || (_cache[8] = ($event: any) => {
        onMouseLeave(btnGroupSizable.value);
        onMouseLeave(timestampSizable.value);
      }),
      ref: (_value, _refs) => {
        _refs['postSizeElement'] = _value
        postSizeElement.value = _value
      },
      class: "post__item resizable",
      style: _normalizeStyle([
        _unref(style) +
        `width:${_unref(postItem).position.width}px; height:${_unref(postItem).position.height}px; z-index:${_unref(postItem).position.z}; background-color:${_unref(postColor)}`
      , {"position":"fixed","opacity":"0.7"}]),
      onDblclick: setDraggable
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
            class: "post__form"
          }, [
            _createElementVNode("input", {
              class: "post__input",
              type: "text",
              placeholder: "제목을 입력하세요",
              value: title.value,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (matchTitle($event)))
            }, null, 40, _hoisted_10)
          ], 32),
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['btnGroupSizable'] = _value
              btnGroupSizable.value = _value
            },
            class: "post__btnGroup hidden"
          }, [
            _createElementVNode("i", {
              class: "far fa-trash-alt",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('delete:post', _unref(postItem)._id)))
            })
          ], 512)
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
            class: "post__form"
          }, [
            _createElementVNode("textarea", {
              class: "post__textarea",
              style: {"height":"100%"},
              value: contents.value,
              placeholder: "내용을 입력하세요",
              onInput: _cache[5] || (_cache[5] = ($event: any) => (matchContents($event)))
            }, null, 40, _hoisted_13)
          ], 32)
        ]),
        _createElementVNode("div", {
          ref: (_value, _refs) => {
            _refs['timestampSizable'] = _value
            timestampSizable.value = _value
          },
          class: "timestamp hidden"
        }, [
          (!_unref(updatedTime))
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(createdTime)) + " 생성됨", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(updatedTime)) + " 수정됨", 1))
        ], 512)
      ])
    ], 36), [
      [_vShow, !_unref(postItem).isDraggable]
    ])
  ]))
}
}

})